import { Button, Col, Row } from "antd"
import React, { useEffect } from "react"
import styles from "./style.module.css"
import cx from "classnames"
import CardBox, { IExtraMore } from "components-old/CardBox"
import { useScrollTop } from "hooks"
import { isAldeia } from "hooks/useAldeia"

interface IEditPageProps {
  children: React.ReactNode
  title?: React.ReactNode | string
  footer?: React.ReactNode
  onBack: any
  midcolStyle?: React.CSSProperties
  contentStyle?: React.CSSProperties
  style?: React.CSSProperties
  footerStyle?: React.CSSProperties
  topActions?: React.ReactNode
  after?: React.ReactNode
  extraTopRight?: React.ReactNode
  className?: string
  extraMore?: IExtraMore[]
  width?: number
  cardStyle?: React.CSSProperties
  hideFooter?: boolean
}

function EditPage(props: IEditPageProps) {
  useScrollTop()

  return (
    <div className={cx(styles.edit_page, props.className, "g_edit_page")} style={props.style}>
      <div className={cx(styles.edit_page_inner, "g_edit_page_inner")}>
        <CardBox
          title={props.title}
          style={{
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.2)",
            width: (isAldeia ? "100%" : props.width) || undefined,
            ...props.cardStyle,
          }}
          onBack={props.onBack}
          // helpText={props.helpText}
          extra={props.topActions}
          extraMore={props.extraMore}
          extraTopRight={props.extraTopRight}
          bodyStyle={isAldeia ? { maxWidth: props.width || undefined, width: "100%" } : {}}
          // extraLeft={[Filters]}
        >
          {/* <Row className={styles.header}>
                    <Col flex={1} style={{ paddingLeft: 16 }}>
                        <Button
                            type="text"
                            icon={<i className="fal fa-chevron-left" />}
                            style={{
                                fontWeight: 400,
                                color: "var(--content-secondary)",
                                height: 38,
                            }}
                            onClick={props.onBack}
                        >
                            Voltar
                        </Button>
                    </Col>
                    <Col style={{ textAlign: "center", marginLeft: -80 }}>{props.title}</Col>
                    <Col
                        flex={1}
                        style={{
                            textAlign: "right",
                            paddingRight: 15,
                        }}
                    >
                        {props.topActions}
                    </Col>
                </Row> */}
          {props.children}
          {!props.hideFooter && (
            <div className={styles.edit_page_footer} style={props.footerStyle}>
              <div className={styles.edit_page_content_midcol} style={{ display: "flex", alignItems: "center", height: "100%" }}>
                {props.footer}
              </div>
            </div>
          )}
        </CardBox>
        {props.after}
      </div>
    </div>
  )
}

export default EditPage
